import defaultColors from "../defaultColors";
import defaultAssets from "../defaultAssets";
const footerLinks = [{
  text: "Feedback",
  href: "https://amsi.ae/en/component/content/article/60-feedback/97-feedback"
}, {
  text: "Privacy Policy",
  href: "https://amsi.ae/en/component/content/article/105"
}, {
  text: "Terms and Conditions",
  href: "https://amsi.ae/en/component/content/article/105"
}, {
  text: "©2020 AMSI",
  href: "https://amsi.ae/"
}];
const amsi = {
  name: "Blue theme for AMSI",
  value: "amsi",
  brand: "AMSI",
  website: "https://amsi.ae",
  colors: { ...defaultColors,
    border: "#e5e5e5",
    primary: "#318ae9",
    primaryLight: "#6eadf0",
    primaryLighter: "#f1c3c4",
    primaryLightest: "#ffebe8",
    primaryDark: "#1360b2",
    error: "#318ae9"
  },
  footerLinks: footerLinks,
  verifyURL: "https://verificationt.amsi.ae/",
  phone: "+971 55 160 ????",
  email: "support@educhain.io",
  assets: { ...defaultAssets
  }
};
export { amsi };